__webpack_require__.p = "https://caracalui.prod.eu-west-1.urc.advertising.amazon.dev/";